export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/mx.3da952ef.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};